var msg = new Array();
msg['ERR_PRIVACY']='Você tem que aceitar a declaração de privacidade.';
msg['ERR_MISSINGFIELDS']='Preencha todos os campos obrigatórios.';
msg['ERR_FILLEMAILFIELD']='Preencha o campo de e-mail.';
msg['ERR_USEREXISTS']='Usuário já existe.';
msg['ERR_INVALIDMAIL']='Endereço de e-mail inválido.';
msg['ERR_CLIENTMANDATORYFIELDS']='Preencha todos os campos obrigatórios';
msg['ERR_NOSIZESELECTED']='Você tem que selecionar um tamanho';
msg['ERR_LOGINREQUIRED']='Login necessário';
msg['ERR_LOGININVALID']='E-mail ou senha inválidos';
msg['ERR_CARRIERMISSING']='Você tem que selecionar primeiro um tipo de envio.';
msg['ERR_CARRIER_COST_MISSING']='Nenhuma taxa disponível para o transportador do país selecionado e peso do pedido.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Apenas o modo de reserva de pedido será habilitado e as taxas de envio serão enviadas por e-mail.';
msg['MSG_ADDEDTOWISHLIST']='Produto adicionado à sua lista de desejos';
msg['MSG_NEWSLETTER_COMPLETED']='Registro bem-sucedido';
msg['MSG_ADDEDTOCART']='Produtos adicionados ao seu carrinho';
msg['MSG_REMOVEDFROMCART']='Produto removido do carrinho';
msg['MSG_DELETEALLPRODUCTS']='Tem certeza de que deseja remover todos os produtos do carrinho?';
msg['DELETEALLPRODUCTSERROR']='Erro ao remover produtos do carrinho';
msg['MSG_WAIT']='Aguarde por favor...';
msg['MSG_SUBJECT_PRODUCTSHARE']=' compartilhou algo com você';
msg['MSG_SENDER_PRODUCTSHARE']='Seu nome';
msg['MSG_MESSAGE_PRODUCTSHARE']='Mensagem';
msg['MSG_MAILSENT']='E-mails enviados';
msg['MSG_MIXED_INTANGIBLE']='Este produto não pode ser comprado junto com produtos que você já tem no seu carrinho de compras.';
msg['MSG_MIXED_CART']='Este produto não pode ser comprado junto com produtos que você já tem no seu carrinho de compras porque estão em depósitos diferentes.';
msg['MSG_INSUFFICIENT_STOCK']='Desculpe, no momento não temos estoque suficiente disponível do produto.';
msg['MSG_APPLIEDVATCHANGED']='Após a atualização dos dados de faturamento, o VAT aplicado ao seu pedido mudou. Verifique o novo valor assim que a página for recarregada.';
msg['MSG_GENERIC_ERROR']='Desculpe, ocorreu um erro.';
msg['MSG_COUPON_ERROR']='O código do cupom inserido não é válido ou já foi utilizado.';
msg['MSG_COUPON_VALID']='O código do cupom inserido foi aceito com sucesso.';
msg['MSG_RECOVEREMAILSENT']='Verifique seu e-mail e insira o código para confirmar a alteração de senha.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Atenção: você não está registrado com este endereço de e-mail ou já está redefinindo sua senha.';
msg['MSG_SUBSCRIPTION_FAILURE']='Certifique-se de que não possui nenhuma outra assinatura ativa.';
msg['MSG_EXTRAUELIMIT']='Você não pode finalizar pedidos com um valor tributável inferior a 2000.00 &euro;';
msg['MSG_RULE_REJECT']='Produto não pode ser adicionado ao carrinho por causa da regra :rule';
msg['LABEL_ARTICLES']='artigos';
msg['LABEL_WARNING']='Aviso';
msg['LABEL_NOTAPPLICABLE']='Não aplicável';
msg['LABEL_ALREADYREGISTEREDUSERES']='Usuários já registrados';
msg['LABEL_SENTINVITES']='Convites enviados';
msg['LABEL_NOTSENTINVITES']='Convites não enviados';
msg['LABEL_INVITES_ALREADY_SENT']='Usuários já convidados';
msg['LABEL_SUBMIT']='Enviar';
msg['LABEL_SELECTALL']='Selecionar tudo';
msg['MSG_MESSAGE_SENT']='Mensagem enviada com sucesso!';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Pedido de devolução criado com sucesso';
msg['MSG_SAVE_SUCCESS'] = 'Salvo com sucesso';
msg['MSG_SUBSCRIBED'] = 'Registrado com sucesso';
msg['MSG_PROFILECONSENT_SAVED'] = 'Suas preferências de contato foram atualizadas';
msg['wrongpassword'] = 'Senha incorreta';
msg['passwordnotcomplex'] = 'Senha não é complexa o suficiente';
msg['MSG_PASSWORD_OK'] = 'Senha alterada corretamente';
msg['MSG_PASSWORD_NOT_EQUAL'] = 'as senhas não coincidem';
msg['MSG_PRIVACY_POLICY'] = 'Você deve aceitar a política de privacidade';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'Passaram-se muitos dias, portanto, a assinatura não pode ser renovada';
msg['MSG_GIFTCARD_SUCCESS'] = 'Seu vale-presente foi aceito';
msg['INVALID_GIFTCARD'] = 'Vale-presente inválido';
msg['ERR_REWIXSYNC_URL']= 'URL inválida';
msg['msg.form.invalidtype'] = 'Ocorreu um erro. Contacte a administração relatando o seguinte: "Tipo de contacto inválido ou ausente."';
msg['login.user.unexisting'] = "Usuário não existente";
msg['msg.form.invalidemail'] = 'Correio eletrónico inválido ou ausente';
msg['msg.form.invalidrecipients'] = 'Ocorreu um erro. Contacte a administração informando o seguinte: "Destinatários de contacto inválidos ou ausentes."';

var portal_livestock_available='DISPONÍVEL';
var portal_livestock_soldout='ESGOTADO';

var activity_online_shop = 'loja online';
var activity_shop = 'loja';
var activity_private_sales = 'vendas privadas';
var activity_outlet = 'outlet';
var activity_online_outlet = 'outlet online';
var activity_store_chain = 'rede de lojas';
var activity_purchasing_group = 'grupo de compras';
var activity_broker = 'corretor/agente';
var activity_ebay_amazon = 'loja eBay/Amazon';
var activity_other = 'outro';

var general='Geral';
var general_personaldata='Dados pessoais';
var general_olduser='Usuário registrado';
var general_newuser='Novo usuário';
var general_username="Nome de usuário";
var general_password="Senha";
var general_contacts='Contatos';
var general_phone='Telefone';
var general_skype='Skype';
var general_website='Website';
var general_fax='Fax';
var general_firstname='Nome';
var general_lastname='Sobrenome';
var general_company='Empresa';
var general_birth='Data de nascimento';
var general_code='Código';
var general_model='Modelo';
var general_quantity='Quantidade';
var general_availability='Disponibilidade';
var general_price='Preço';
var general_warning='Aviso';
var general_dispatchto='Nome da empresa/Destinatário';
var general_careof='C/O';
var general_vat='IVA';
var general_address='Endereço';
var general_addresstype='Tipo de endereço';
var general_addressnumber='Número';
var general_city='Cidade';
var general_prov='Província';
var general_zip='CEP';
var general_mobile='Celular';
var general_notes='Notas';
var general_orders='Pedidos';
var general_fgfdiscounts='Amigos e descontos';
var general_myprofile='Meu perfil';
var general_pieces='pcs';
var general_size_table='Tabela de tamanhos';
var general_details='Detalhes';
var general_invoice='Fatura';
var general_creditnote='Nota de crédito';
var general_cart= 'Carrinho de compras';
var general_country='País';
var general_carrier='Transportadora';
var general_dispatch_address='Endereço de envio';
var general_invoice_address='Endereço de faturamento';
var general_receive_newsletter='Receber newsletter';
var general_copydispatchfrombilldata='Copiar dos dados de faturamento';
var general_instructions="Instruções";
var general_add="Adicionar";
var general_status="Status";
var general_toomanyfilters="Você atingiu o número máximo de filtros permitidos.";

var help_addresstype='Rua, Praça, Avenida, ...';
var help_address='Nome da rua';
var help_dispatchmobile='Este número será usado pela transportadora.';
var help_ordercfpiva='Um valor em branco adicionará automaticamente um IVA de 20% ao valor do pedido.';
var help_cf='Insira o seu CPF';

var buttons_save='Salvar';
var buttons_changepw='Alterar senha';
var buttons_close='Fechar';
var buttons_continue='Continuar';
var buttons_confirm='Confirmar';
var buttons_cancel='Cancelar';
var buttons_invite='Convidar';
var buttons_continueshopping='Continuar comprando';
var buttons_gocheckout='Ir para o checkout';

var messages_product_soldout='Produto esgotado.';
var messages_noselection='Nenhuma seleção';
var messages_invaliddata='Dados inválidos.';
var messages_recoverpassword='Recuperar senha';
var messages_recoverpassword_info='Insira o e-mail com o qual se inscreveu<br/>Você receberá um e-mail com as instruções para recuperar sua senha';
var messages_invitefriends='Convide seus amigos';
var messages_confirmpassword='Confirmar senha';
var messages_sendingmail='Enviando e-mail...';
var messages_mailsent='E-mail enviado.';
var messages_password='Senha';
var messages_confirmpassword='Confirmar senha';
var messages_requiredfield='Campo obrigatório';

var subscribe_personaldata='Dados pessoais';
var subscribe_privacyintro='Você deve aceitar a seguinte condição para prosseguir com a assinatura.';
var subscribe_privacydisclaimer = 'Você deve aceitar o aviso de privacidade para prosseguir com a assinatura.';
var subscribe_privacy1='Aceito o aviso de privacidade';
var subscribe_privacy2='Aceito que meus dados pessoais possam ser usados por outras empresas para campanhas de marketing (opcional)';

var order_status='Status'
var order_date='Data'
var order_dispatchdate='Enviado';

var returnedgoods_requests="Pedido de devolução";
var returnedgoods_motivations="Motivo da devolução";
var returnedgoods_requestcode="Código do pedido de devolução";
var returnedgoods_requestdate="Data do pedido";
var returnedgoods_motivations_1="Não gostei do produto";
var returnedgoods_motivations_2="O produto é muito grande/pequeno";
var returnedgoods_motivations_3="O produto está danificado";
var returnedgoods_motivations_4="O produto não corresponde ao solicitado";
var returnedgoods_motivations_5="O produto não está na embalagem";
var returnedgoods_motivations_other = "Outro";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Pendente';
i18nOrderStatus[1]='Em pagamento';
i18nOrderStatus[2]='Confirmado';
i18nOrderStatus[3]='Enviado';
i18nOrderStatus[4]='Entregue';
i18nOrderStatus[5]='Reservado';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Cancelado';
i18nOrderStatus[2001]='Erro';
i18nOrderStatus[3001]='Em processo';
i18nOrderStatus[3002]='Pronto';

i18nOrderStatus[1000]='Pagamento Cancelado';
i18nOrderStatus[2002]='Verificação de pagamento falhou';
i18nOrderStatus[2003]='Reembolsado';
i18nOrderStatus[2005]='Rejeitado';
i18nOrderStatus[3003]='Não enviável';
i18nOrderStatus[5001]='Não autorizado';
i18nOrderStatus[5002]='Autorizado';
i18nOrderStatus[5003]='Dropshipping - Crescendo';
